import { useState, useEffect } from "react";

// Props: player (Spotify.Player)
export default function SpotifyVolumeSlider({ player }) {
    const [volume, setVolume] = useState(0.5);
    const [lastVolume, setLastVolume] = useState(0.5);

    // Get initial volume from player
    useEffect(() => {
        if (!player) return;
        player.getVolume().then(vol => setVolume(vol));
    }, [player]);

    // Handle slider change
    const handleChange = async (e) => {
        const newVolume = Number(e.target.value);
        setVolume(newVolume);
        if (player) await player.setVolume(newVolume);
    };

    const handleMute = () => {
        if(volume === 0) {
            handleChange({target: {value: lastVolume}})
        } else {
            setLastVolume(volume)
            handleChange({target: {value: 0}})
        }
    }

    let volumeEmoji = '🔊';
    if( .2 <= volume && volume <= .6) volumeEmoji = '🔉' 
    else if (volume <= .2 && volume !== 0 ) volumeEmoji = '🔈' 
    else if (volume === 0) volumeEmoji = '🔇'

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center",  
            userSelect: "none",
            WebkitUserSelect: "none",
            MozUserSelect: "none",
            msUserSelect: "none"
        }}>
            <input
                type="range"
                min={0}
                max={1}
                step={0.01}
                value={volume}
                onChange={handleChange}
                style={{
                    margin: 0,
                    writingMode: "vertical-lr", // vertical orientation
                    direction: 'rtl',
                    width: 24,
                    height: 80,
                    accentColor: "#afafaf",
                    cursor: "pointer"
                }}
            />
            <span style={{ fontSize: 12, color: "#bbb", cursor: "pointer"}} onClick={handleMute}>
                {volumeEmoji}
            </span>
        </div>
    );
}